import { useState, useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import config from '../../app.json';
import { Button, Spinner } from 'react-bootstrap';
import FieldTextarea from '../Fields/FieldTextarea';
import Navbar from '../Navbar/Navbar';
import './ChatGpt.scss';
import logo from '../../Assets/Images/monkey-face.svg';
import AlertComponent from '../AlertComponent';

const socket = io(config.Socket_URl, {
  reconnection: true,         // Automatically reconnect on disconnect
  reconnectionAttempts: 5,    // Try to reconnect 5 times
  reconnectionDelay: 1000,    // Delay between reconnections (1 sec)
  pingInterval: 10000,        // Send ping every 10 seconds
  pingTimeout: 5000           // Timeout if no pong is received within 5 seconds
});

export default function Chat() {
  const [activeTab, setActiveTab] = useState('chat'); // 'chat' or 'image'
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [imagePrompt, setImagePrompt] = useState('');
  const [loading, setLoading] = useState(false);
  const [activeAlert , setActiveAlert] = useState(false)
  // const messagesEndRef = useRef(null); // Reference for scrolling
  const chatContainerRef = useRef(null);

  useEffect(() => {

    socket.on('connect', () => {
      console.log('Connected to server ✅');
    });

    socket.on('disconnect', () => {
      console.log('Disconnected from server ❌');
    });

    socket.on('pong', () => {
      console.log('Pong received 🟢');
    });

    socket.on('receiveMessage', (data) => {
      setMessages((prev) => {
        return prev.map((msg) =>
          msg.id === data.id ? { ...msg, botReply: data.botReply } : msg
        );
      });
      setLoading(false);
    });

    socket.on('imageGenerated', (data) => {
      setMessages((prev) => {
        return prev.map((msg) =>
          msg.id === data.id ? { ...msg, imageUrl: data.imageUrl } : msg
        );
      });
      setLoading(false);
    });

    socket.on('errorMessage', (data) => {
      setMessages((prev) => {
        return prev.map((msg) => {
          return msg.id === data.id
            ? { ...msg, botReply: data.error, type: 'error' } // Replace the processing message
            : msg;
        });
      });

      setLoading(false);
    });

    const pingInterval = setInterval(() => {
      if (socket.connected) {
        console.log('Sending ping... 🔥');
        socket.emit('ping');
      }
    }, 5 * 60 * 1000); // Every 10 seconds

    return () => {
      socket.off('receiveMessage');
      socket.off('errorMessage');
      socket.off('imageGenerated');
      clearInterval(pingInterval);
    };

  }, []);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  const sendMessage = () => {
    if (!message.trim()) return;
    const tempId = Date.now(); // Temporary ID to track messages
    setLoading(true);

    // Show user message immediately
    setMessages((prev) => [
      ...prev,
      { id: tempId, type: 'chat', message, botReply: 'Processing...' },
    ]);

    socket.emit('sendMessage', {
      message,
      userId: 1,
      id: tempId,
      type: 'chat',
    });
    setMessage('');
  };

  const generateImage = () => {
    if (!imagePrompt.trim()) return;
    const tempId = Date.now();
    setLoading(true);

    // Show prompt immediately
    setMessages((prev) => [
      ...prev,
      { id: tempId, type: 'image', prompt: imagePrompt, imageUrl: null },
    ]);

    socket.emit('generateImage', {
      prompt: imagePrompt,
      userId: 1,
      id: tempId,
      type: 'image',
    });
    setImagePrompt('');
  };

  const speakMessage = (text) => {
    if ('speechSynthesis' in window) {
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.rate = 1;
      utterance.pitch = 1;
      window.speechSynthesis.speak(utterance);
    } else {
      alert('Text-to-Speech is not supported in this browser.');
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault(); // Prevent scrolling inside the textarea
    } else if (
      event.key === 'Enter' &&
      !event.shiftKey &&
      !event.ctrlKey &&
      !event.altKey &&
      !event.metaKey
    ) {
      event.preventDefault(); // Prevent default Enter behavior (new line)
      activeTab === 'chat' ? sendMessage() : generateImage(); // Call send function
    }
  };

  const handleAlert = ()=>{

    if(messages.length>0){
      setActiveAlert(true)

        return AlertComponent(
        "Confirm",
        `Clear conversation? This can't be undone.`,
        { icon: `warning`, showConfirmButton: true, showCancelButton: true, cancelButtonText: "No" },
        () => {
          window.location.reload();
        },
        false,
        "Yes",
        () => {
          setActiveAlert(false);
        }
        );
    }
  }

  return (
    <div>
      <div className='d-flex flex-column w-100 vh-100'>
      
        <Navbar/>
        <div
          className={`chat-gpt-main-wrapper ${
            messages.length === 0 && 'center'
          }`}>
          <div
            ref={chatContainerRef}
            className={`chat-container flex-grow-1 overflow-auto p-3 mt-5 w-100 w-md-75 w-lg-50 ${
              messages.length === 0 ? 'd-none' : ''
            }`}
            key={messages.length}
            style={{ margin: '0 auto' }}>
            {messages.map((msg) => (
              <div className='d-flex flex-column' key={msg.id}>
                {/* User's Message */}
                <div className='d-flex justify-content-end '>
                <p className="d-inline-block bg-primary text-white bg-opacity-75 rounded-4 text-dark mb-1 px-3 py-2 text-break" style={{ maxWidth: "88%" }}>
                    {msg.prompt || msg.message}
                  </p>
                </div>

                {/* Bot's Reply */}
                <div
                  className={
                    msg.type === 'image'
                      ? 'image-message-container mt-3'
                      : 'd-flex justify-content-start mt-3'
                  }>
                  {msg.type === 'error' ? (
                    <p className='bg-danger rounded-4 text-white px-3 py-2'>
                      ⚠️ {msg.botReply}
                    </p>
                  ) : msg.type === 'image' ? (
                    msg.imageUrl ? (
                      <ImageWithLoader
                        imageUrl={msg.imageUrl}
                        altText={msg.prompt}
                      />
                    ) : (
                      <p className='d-inline-block bg-light rounded-4 text-dark mb-1 px-3 py-2'>
                        Processing...
                      </p>
                    )
                  ) : (
                    <p className='bg-light rounded-4 px-3 py-2'>
                      {msg.botReply}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div
            className={`d ${
              messages.length === 0 ? 'move-to-center' : 'move-to-down'
            }`}
            style={{ width: '100%' }}>
            <h1
              className={`${messages.length !== 0 ? 'd-none' : ''}`}
              style={{ color: '#757575' }}>
              Welcome to <img src={logo} alt='app-logo'></img> SocialChimp AI
            </h1>
            <div className='p-3 gap-2 tab-buttons-container'>
                <svg
                xmlns='http://www.w3.org/2000/svg'
                height='25'
                width='25'
                viewBox='0 0 1024 1024'
                fill='white'
                style={{ cursor: "pointer" ,flexShrink:0 }}
                onClick={handleAlert}
              >
                <path d='M648.533 981.333h-358.4c-76.8 0-119.467 0-153.6-17.067s-59.733-42.667-72.533-72.533c-21.333-38.4-21.333-81.067-21.333-157.867v-358.4c0-76.8 0-119.467 17.067-153.6s42.667-59.733 72.533-72.533c38.4-21.333 81.067-21.333 157.867-21.333h179.2c25.6 0 42.667 17.067 42.667 42.667s-17.067 42.667-42.667 42.667h-179.2c-64 0-98.133 0-115.2 8.533s-29.867 21.333-38.4 38.4c-8.533 17.067-8.533 51.2-8.533 115.2v358.4c0 64 0 98.133 8.533 115.2s21.333 29.867 38.4 38.4c17.067 8.533 51.2 8.533 115.2 8.533h358.4c64 0 98.133 0 115.2-8.533s29.867-21.333 38.4-38.4c8.533-17.067 8.533-51.2 8.533-115.2v-179.2c0-25.6 17.067-42.667 42.667-42.667s42.667 17.067 42.667 42.667v179.2c0 76.8 0 119.467-17.067 153.6s-42.667 59.733-72.533 72.533c-38.4 21.333-81.067 21.333-157.867 21.333zM413.867 725.333h-72.533c-25.6 0-42.667-17.067-42.667-42.667v-72.533c0-21.333 0-38.4 4.267-51.2s8.533-25.6 17.067-38.4c8.533-12.8 17.067-21.333 34.133-38.4l409.6-409.6c51.2-51.2 136.533-51.2 187.733 0s51.2 136.533 0 187.733l-409.6 409.6c-17.067 17.067-25.6 25.6-38.4 34.133s-25.6 12.8-38.4 17.067c-17.067 4.267-29.867 4.267-51.2 4.267z' />
              </svg>
              <button
                className={`flex-fill rounded-4 py-2 px-4 btn ${
                  activeTab === 'chat' ? 'btn-primary text-white ' : 'btn-light'
                }`}
                onClick={() => !loading && setActiveTab('chat')}
                disabled={loading}>
                <svg
                  className='me-2'
                  width='15'
                  height='15'
                  viewBox='0 0 20 20'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M8 15H10M10 15H12M10 15V5M10 5H5V6M10 5H15V6M3 19H17C18.1046 19 19 18.1046 19 17V3C19 1.89543 18.1046 1 17 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19Z'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
                ChatGPT
              </button>
              <button
                className={`flex-fill rounded-4  py-2 btn ${
                  activeTab === 'image' ? 'btn-primary text-white' : 'btn-light'
                }`}
                onClick={() => !loading && setActiveTab('image')}
                disabled={loading}>
                <svg
                  className='me-2'
                  width='15'
                  height='15'
                  viewBox='0 0 20 20'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M1.00005 16.0001C1 15.9355 1 15.8689 1 15.8002V4.2002C1 3.08009 1 2.51962 1.21799 2.0918C1.40973 1.71547 1.71547 1.40973 2.0918 1.21799C2.51962 1 3.08009 1 4.2002 1H15.8002C16.9203 1 17.4801 1 17.9079 1.21799C18.2842 1.40973 18.5905 1.71547 18.7822 2.0918C19 2.5192 19 3.07899 19 4.19691V15.8031C19 16.2881 19 16.6679 18.9822 16.9774M1.00005 16.0001C1.00082 16.9884 1.01337 17.5058 1.21799 17.9074C1.40973 18.2837 1.71547 18.5905 2.0918 18.7822C2.5192 19 3.07899 19 4.19691 19H15.8036C16.9215 19 17.4805 19 17.9079 18.7822C18.2842 18.5905 18.5905 18.2837 18.7822 17.9074C18.9055 17.6654 18.959 17.3813 18.9822 16.9774M1.00005 16.0001L5.76798 10.4375L5.76939 10.436C6.19227 9.9426 6.40406 9.69551 6.65527 9.60645C6.87594 9.52821 7.11686 9.53004 7.33643 9.61133C7.58664 9.70397 7.79506 9.95387 8.21191 10.4541L10.8831 13.6595C11.269 14.1226 11.463 14.3554 11.6986 14.4489C11.9065 14.5313 12.1357 14.5406 12.3501 14.4773C12.5942 14.4053 12.8091 14.1904 13.2388 13.7607L13.7358 13.2637C14.1733 12.8262 14.3921 12.6076 14.6397 12.5361C14.8571 12.4734 15.0896 12.4869 15.2988 12.5732C15.537 12.6716 15.7302 12.9124 16.1167 13.3955L18.9822 16.9774M18.9822 16.9774L19 16.9996M13 7C12.4477 7 12 6.55228 12 6C12 5.44772 12.4477 5 13 5C13.5523 5 14 5.44772 14 6C14 6.55228 13.5523 7 13 7Z'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
                AI Image
              </button>
            </div>{' '}
            {/* Tab Selection */}
            {/* Input Section */}
            <div
              className={`d-flex gap-2 align-items-end transition-container chat-input-container ${
                messages.length > 0 ? 'moved-down' : ''
              }`}>
              <FieldTextarea
                label=''
                type='text'
                onChange={(e) =>
                  activeTab === 'chat'
                    ? setMessage(e.target.value)
                    : setImagePrompt(e.target.value)
                }
                value={activeTab === 'chat' ? message : imagePrompt}
                required={true}
                classNames='w-100 border-light curvy-textarea'
                rows={3}
                onKeyDown={handleKeyDown}
                maxLength={null}
                placeholder={activeTab === 'chat' ? 'Ask anything...' : 'Create anything...'}
              />
              <Button
                className='d-inline-block rounded-4 text-center px-4 py-2'
                style={{ minWidth: '120px' }} // Ensures no shrinking
                onClick={activeTab === 'chat' ? sendMessage : generateImage}
                disabled={loading}>
                {loading
                  ? activeTab === 'chat'
                    ? 'Sending...'
                    : 'Generating...'
                  : activeTab === 'chat'
                  ? 'Send'
                  : 'Generate'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const ImageWithLoader = ({ imageUrl, altText }) => {
  const [loading, setLoading] = useState(true);

  return (
    <div
      className='position-relative mb-3'
      style={{ width: '50%', height: '50%' }}>
      {loading && (
        <div
          className='d-flex align-items-center h-100 justify-content-center position-absolute w-100'
          style={{
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            borderRadius: '8px',
          }}>
          <Spinner animation='border' variant='light' />
        </div>
      )}
      <img
        src={imageUrl}
        alt={altText}
        className='h-100 rounded shadow w-100 img-fluid'
        onLoad={() => setLoading(false)}
        style={loading ? { display: 'none' } : {}}
      />
    </div>
  );
};
